import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/mentions-legales/page.tsx");
